import { RegenerateButton } from './RegenerateButton'
import { UploadButton } from './UploadButton'
import Styles from './Logos.module.scss'

interface MissingLogoProps {
  onUpload: (file: File) => void
  onRegenerate?: () => void
}

export const MissingLogo = ({ onUpload, onRegenerate }: MissingLogoProps) => {
  return (
    <div className={Styles.missingLogoButtons}>
      <UploadButton onUpload={onUpload} />
      {onRegenerate && <RegenerateButton onRegenerate={onRegenerate} />}
    </div>
  )
}
